import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { SelectControl, SelectItem } from 'src/app/form-controls/select/select.control';
import { SheetItemService } from 'src/app/services/sheet-item.service';
import { ItemTypeMetadata, SheetItemFormBase } from 'src/app/services/sheets-renderer.service';
import { Row } from 'src/app/types/aggregate-graph.types';
import { PhysioLevel, PhysiotherapyInstruction } from 'src/app/types/sheet-instruction.types';
import { InstructionsFormComponent } from '../../instructions-form/instructions-form.component';

interface PhysiotherapyInstructionFormGroup {
	physioLevel: FormControl<PhysioLevel | null>;
}

@Component({
    selector: 'app-physiotherapy-item-form',
    templateUrl: './physiotherapy-item-form.component.html',
    styleUrl: './physiotherapy-item-form.component.scss',
    imports: [ReactiveFormsModule, InstructionsFormComponent, SelectControl],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PhysiotherapyItemFormComponent implements SheetItemFormBase, OnInit {

	@Input() instructionTypeName!: string;
	@Input() item!: Row | null;
	@Input() minDate!: string;
	@Input() maxDate!: string;
	@Input() instructionsFormArray!: FormArray;
	@Input() itemConfig!: ItemTypeMetadata;

	physioLevels: SelectItem[] = [
		{ text: 'Level 1 Passive', value: PhysioLevel.Active },
		{ text: 'Level 2 Active assisted', value: PhysioLevel.Passive },
		{ text: 'Level 3 Intensive', value: PhysioLevel.Intensive }
	];

	constructor(private sheetItemService: SheetItemService, private formBuilder: FormBuilder) {
	}

	ngOnInit() {
		this.sheetItemService.getInstructions(this.item, this.instructionTypeName, this.itemConfig.scheduleConfig.defaultScheduleType, this.itemConfig.scheduleConfig.defaultRepeatingScheduleFrequency).forEach(instruction => {
			const group: FormGroup<PhysiotherapyInstructionFormGroup> = this.sheetItemService.buildExistingInstructionGroup(this.instructionTypeName, instruction);
			const physiotherapyInstruction = instruction as PhysiotherapyInstruction;
			group.addControl('physioLevel', this.formBuilder.control(physiotherapyInstruction.physioLevel ?? null));
			this.instructionsFormArray.push(group);
		});
	}

	addInstruction() {
		const group: FormGroup<PhysiotherapyInstructionFormGroup> = this.sheetItemService.getNewInstructionGroup(this.instructionTypeName, this.itemConfig.scheduleConfig.defaultScheduleType, this.itemConfig.scheduleConfig.defaultRepeatingScheduleFrequency);
		group.addControl('physioLevel', this.formBuilder.control(null));
		this.instructionsFormArray.push(group);
	}
}